import {
  deleteExternalProject,
  editFundsSourceConfig,
  getAgentProjectList,
  getFinanceProjectList,
  getFundsSourceConfigList,
  getProjectFundsNatureDetail,
  getProjectFundsSourceDetail,
  getProjectHistoryRecordList,
  getProjectSourceList,
  interBatchTransforExternal,
  projectMergeInit,
  projectSplitInit,
  pushInternalProject,
  saveProjectFundsNature,
  saveProjectFundsSource,
} from '../services';

export default {
  namespace: 'projectManageSummary',
  state: {},
  effects: {
    // 经办人查询列表
    *getAgentProjectList({ payload }, { call }) {
      return yield call(getAgentProjectList, payload);
    },

    // 获取历史记录列表
    *getProjectHistoryRecordList({ payload }, { call }) {
      return yield call(getProjectHistoryRecordList, payload);
    },

    // 财务查询列表
    *getFinanceProjectList({ payload }, { call }) {
      return yield call(getFinanceProjectList, payload);
    },

    // 项目来源查询
    *getProjectSourceList({ payload }, { call }) {
      return yield call(getProjectSourceList, payload);
    },

    // 项目拆分
    *projectSplitInit({ payload }, { call }) {
      return yield call(projectSplitInit, payload);
    },

    // 项目合并
    *projectMergeInit({ payload }, { call }) {
      return yield call(projectMergeInit, payload);
    },

    // 预算项目下发
    *pushInternalProject({ payload }, { call }) {
      return yield call(pushInternalProject, payload);
    },

    // 内部项目-批量转为外部项目
    *interBatchTransforExternal({ payload }, { call }) {
      return yield call(interBatchTransforExternal, payload);
    },

    // 删除外部项目
    *deleteExternalProject({ payload }, { call }) {
      return yield call(deleteExternalProject, payload);
    },

    // 查询单位资金来源配置
    *getFundsSourceConfigList({ payload }, { call }) {
      return yield call(getFundsSourceConfigList, payload);
    },

    // 编辑单位资金来源配置
    *editFundsSourceConfig({ payload }, { call }) {
      return yield call(editFundsSourceConfig, payload);
    },

    // 内部项目-项目资金来源分配详情
    *getProjectFundsSourceDetail({ payload }, { call }) {
      return yield call(getProjectFundsSourceDetail, payload);
    },

    // 内部项目-项目资金来源分配
    *saveProjectFundsSource({ payload }, { call }) {
      return yield call(saveProjectFundsSource, payload);
    },

    // 内部项目-项目资金性质详情
    *getProjectFundsNatureDetail({ payload }, { call }) {
      return yield call(getProjectFundsNatureDetail, payload);
    },

    // 内部项目-项目资金性质保存
    *saveProjectFundsNature({ payload }, { call }) {
      return yield call(saveProjectFundsNature, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
